import { useState } from 'react'
import { useAdminAuth } from '../context/AdminAuthContext'
import { adminApi, getApiErrorMessage } from '../services/adminApi'
import { Alert, Button, Card, Input, PageHeader } from '../components/ui'

export default function Profile() {
  const { admin, isRevenda, refreshMe } = useAdminAuth()
  const [email, setEmail] = useState(admin?.email || '')
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const save = async (e) => {
    e.preventDefault()
    setError('')
    setMessage('')
    setLoading(true)
    try {
      await adminApi.updateProfile({
        email,
        current_password: currentPassword,
        new_password: newPassword || undefined,
      })
      setMessage('Perfil atualizado com sucesso.')
      setCurrentPassword('')
      setNewPassword('')
      await refreshMe()
    } catch (err) {
      setError(getApiErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }

  if (isRevenda) {
    return (
      <div className="space-y-4">
        <PageHeader eyebrow="Conta" title="Meu perfil" description="Informações da conta de revenda autenticada." icon="fa-user-circle" />
        <Alert type="info">
          Conta de revenda ({admin?.email}). Alterações de credenciais são feitas pelo administrador master em Revendas.
        </Alert>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Conta" title="Meu perfil" description="Atualize suas credenciais de acesso administrativo." icon="fa-user-circle" />
      {error && <Alert type="error">{error}</Alert>}
      {message && <Alert type="success">{message}</Alert>}
      <Card className="max-w-2xl" title="Credenciais" description="Confirme sua senha atual para salvar alterações.">
        <form onSubmit={save} className="space-y-4">
          <Input label="E-mail" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <Input
            label="Senha atual"
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
          <Input
            label="Nova senha (opcional)"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <Button type="submit" disabled={loading}>
            {loading ? 'Salvando…' : 'Salvar alterações'}
          </Button>
        </form>
      </Card>
    </div>
  )
}
